__turbopack_context__.v({
  "iconButton": "_1DH82W_iconButton",
  "preferencesDetailsModal": "_1DH82W_preferencesDetailsModal",
  "preferencesDetailsModalContent": "_1DH82W_preferencesDetailsModalContent",
  "preferencesDetailsModalHeader": "_1DH82W_preferencesDetailsModalHeader",
  "preferencesDetailsModalList": "_1DH82W_preferencesDetailsModalList",
});
